import { Table, TableProps } from '@mui/material';

/**
 * A compact MUI Table with consistent padding and row height.
 * Use this instead of <Table> directly for uniform styling.
 */
export default function CompactTable(props: TableProps) {
    return (
        <Table
            size="small"
            padding="none"
            sx={{
                '& .MuiTableRow-root': { height: 30 },
                '& .MuiTableCell-root': {
                    px: 0.75,
                    py: 0.25,
                    fontSize: 14,
                    lineHeight: 1.2,
                },
                '& .MuiCheckbox-root': { p: 0.2 },
                '& .MuiSvgIcon-root': { fontSize: 24 },
                ...props.sx, // allow overrides
            }}
            {...props}
        />
    );
}
